// Phase 5.1 — Mugizh-admin Customers (static mockup) migrated to shadcn/Tailwind.
//
// This admin screen has no dispatch/API — it renders hardcoded rows. UI only:
// antd Table/Dropdown/Menu/Drawer/Form → shared DataTable + DropdownMenu + a
// shadcn Sheet form. The mock `data` is unchanged.
import React, { useMemo, useState } from 'react'
import { ColumnDef } from '@tanstack/react-table';
import { MoreVertical, Plus } from 'lucide-react';
import AppConstant from '../Globals/AppConstants';
import { DataTable } from '../shared/data-table';
import { PageHeader } from '../shared/page-header';
import { Button } from 'ui/button';
import { Input } from 'ui/input';
import { Label } from 'ui/label';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from 'ui/sheet';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'ui/dropdown-menu';

const CustomerAdmin = () => {
  const [open, setOpen] = useState(false);

  const data = [
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
    { name: 'Loren Ipsum', mobileNo: '9988776655', purchaseHistory: 'View' },
  ];

  const handleDrawer = () => setOpen((curr) => !curr);

  const columns = useMemo<ColumnDef<any, any>[]>(
    () => [
      { id: 'name', header: 'Name', cell: ({ row }) => row.original?.name },
      { id: 'mobileNo', header: 'Mobile No.', cell: ({ row }) => row.original?.mobileNo },
      {
        id: 'purchaseHistory',
        header: 'Purchase History',
        cell: ({ row }) => <span className="cursor-pointer text-primary underline">{row.original?.purchaseHistory}</span>,
      },
      {
        id: 'action',
        header: 'Action',
        cell: () => (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Row actions">
                <MoreVertical className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={handleDrawer}>{AppConstant?.edit}</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ),
      },
    ],
    []
  );

  return (
    <div className="mz h-full overflow-y-auto px-6 py-4">
      <PageHeader
        title="Customer"
        actions={<Button onClick={handleDrawer}><Plus className="mr-1 h-4 w-4" /> Add</Button>}
      />
      <DataTable columns={columns} data={data} />

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="flex w-full flex-col gap-0 p-0 sm:max-w-md">
          <SheetHeader className="border-b px-5 py-4">
            <SheetTitle>Create Customer</SheetTitle>
          </SheetHeader>
          <div className="flex flex-1 flex-col gap-4 overflow-y-auto p-5">
            <div className="space-y-1.5">
              <Label>Name</Label>
              <Input />
            </div>
            <div className="space-y-1.5">
              <Label>Contact No.</Label>
              <Input />
            </div>
            <div className="mt-auto flex justify-end gap-2 pt-2">
              <Button variant="outline" onClick={() => setOpen((curr) => !curr)}>Cancel</Button>
              <Button>Create</Button>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  )
}

export default CustomerAdmin
